// export const baseURL = "http://localhost:5000/api/v1/";
export const baseURL = "https://smsapi.msiddiquesteel.com/api/v1/";

// export const SocketURL = 'http://localhost:5000';
export const SocketURL = 'https://smsapi.msiddiquesteel.com';

// export const imageURL = "http://localhost:5000/";
export const imageURL = "https://smsapi.msiddiquesteel.com/";